import React from "react";
import { Helmet } from "react-helmet";
import { Grid, Container } from "@mui/material";
import IndexComponent from "../../components/IndexComponent";
import { mainBackgroundStyles } from "../../styles/common";

function IndexPage() {
  return (
    <>
      <Helmet>
        <title>Select account</title>
      </Helmet>
      <Grid
        container
        spacing={0}
        sx={mainBackgroundStyles}
      >
        <Container maxWidth={false}>
          <IndexComponent />
        </Container>
      </Grid>
    </>
  );
}

export default IndexPage;
